import React from 'react';

import {labels} from '../../../../../util/utils';

import OutputText from '@ey/canvascoreservices/OutputText';
import {contactListColumnIds} from '../../../../../util/uiconstants';

const IsInternalColumn = ({item}) => {
	let text = labels.columnType;
	if (item !== null) text = item.isInternal ? labels.internal : labels.external;

	return (
		<OutputText body2 light ellipsis title={text}>
			{text}
		</OutputText>
	);
};

export const config = (labels) => ({
	id: contactListColumnIds.isInternal,
	label: labels.columnType,
	propName: 'isInternal',
	width: 'var(--px-150)',
	sortBy: ['isInternal', 'name'],
	customCell: (item) => {
		const props = {item};
		return <IsInternalColumn {...props} />;
	}
});
